<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title class="project white--text">
          <div class="headline">Survey Questions</div>
        </v-card-title>
        <v-card-text>
          <!-- start question section -->
          <span class="font-weight-bold">Note:Here star mark (<span class="red--text">*</span>) is required.</span>
          <br>
          <div 
          v-for="(ques,index) in questionsData"
          v-bind:key="index"
          >
            <!-- question part -->
            <div>
              <span>{{index+1}}.</span>
                <span v-if="project_language ==1 || project_language ==3">
                <span class="font-weight-bold">Question Title English:</span> &nbsp;&nbsp;&nbsp;{{ ques.question }}
                  <span class="red--text headline" v-if="ques.required_optional == 1">
                    *
                  </span>
                </span>
                <br />
                <span v-if="project_language ==2 || project_language ==3">
                &nbsp;&nbsp;&nbsp; <span class="font-weight-bold">Question Title Bangla:</span> &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }} <br />
                  <span class="red--text headline" v-if="ques.required_optional == 1">
                    *
                  </span>
                </span> 
                <div v-if="ques.ui_category_id == 15">
                  <span v-if="ques.contact_info.first_name == '1'">
                      First Name: _________
                  </span>
                  <span v-if="ques.contact_info.middle_name == '1'">
                    <br />  Middle Name: _________
                  </span>
                  <span v-if="ques.contact_info.last_name == '1'">
                    <br />  Last Name: _________
                  </span>
                  <span v-if="ques.contact_info.phone == '1'">
                    <br />
                    <v-icon small>
                      call </v-icon>Phone: _________
                  </span>
                  <span v-if="ques.contact_info.email == '1'">
                    <br />email: _________
                  </span>
                  <span v-if="ques.contact_info.address == '1'">
                    <br /><v-icon small>
                      home </v-icon><span class="font-weight-bold"> Address:</span>
                    <br />Country: _________ <br />Division: _________
                    <br />District : _________ <br />Area: _________
                    <br />Road No: _________ <br />House No: _________
                  </span>
                </div>
                <!-- option and multiple image section -->
                <div v-if="ques.ui_category_id ==1 || ques.ui_category_id ==2 || ques.ui_category_id ==4 || ques.ui_category_id ==14">
                    <div v-if="ques.image_options && ques.ui_category_id ==14">
                      <span v-for="(option, i) in (ques.image_options)" :key='i'>
                        <v-img height="150" width="200" :src="baseUrl + option.url"></v-img>
                        <a :href="baseUrl + option.url" target="_blank">download</a>
                        <div class="mt-3"></div>
                      </span>
                    </div>
                    <div v-else>
                      <div v-if="ques.options && (project_language ==1 || project_language ==3)">
                        <span class="font-weight-bold">Option English:</span> <br>
                        <span v-for="(option, i) in (ques.options)" :key='i'>
                          <v-icon small>
                          radio_button_unchecked
                          </v-icon>
                          {{option.title}}<br> 
                        </span>
                      </div>
                      <div v-if="ques.bangla_options && (project_language ==2 || project_language ==3)">
                        <br> <span class="font-weight-bold">Option Bangla:</span> <br>
                        <span v-for="(option, i) in (ques.bangla_options)" :key='i'>
                          <v-icon small>
                          radio_button_unchecked
                          </v-icon>
                          {{option.title}}<br> 
                        </span>
                      </div>
                    </div>
                </div>
                <!-- instruction and description -->
                <div>
                  <span
                    v-if="ques.instruction != null && (project_language ==1 || project_language ==3)">
                    <span class="font-weight-bold"> Instruction:</span> &nbsp;&nbsp;&nbsp;<div v-html="parseDataToJson(ques.instruction.instruction)"></div>
                  </span>
                  <span
                    v-if="ques.instruction_bangla != null && (project_language ==2 || project_language ==3)">
                    <span class="font-weight-bold"> Instruction Bangla:</span>  &nbsp;&nbsp;&nbsp;<div v-html="parseDataToJson(ques.instruction_bangla.instruction_bangla)"></div>
                  </span>

                  <span
                    v-if="ques.description != null && (project_language ==1 || project_language ==3)">
                    <span class="font-weight-bold"> Description:</span>&nbsp;&nbsp;&nbsp;<div v-html="parseDataToJson(ques.description.description)"></div>
                  </span>
                  <span
                    v-if="ques.description_bangla != null && (project_language ==2 || project_language ==3)">
                    <span class="font-weight-bold"> Description Bangla:</span>&nbsp;&nbsp;&nbsp;<div v-html="parseDataToJson(ques.description_bangla.description_bangla)"></div>
                  </span>
                </div>
                <!-- multiple answer -->
                <div v-if="ques.ui_category_id ==2">
                  <span class="font-weight-bold">Multiple ans:</span>
                  <v-icon small class="mr-1">check_box_outline_blank</v-icon>
                  <span v-if="ques.multiple_answer ==1">yes</span>
                  <span v-else>no</span>
                </div>
                <!-- range slider star rating -->  
                <div v-if="ques.ui_category_id ==6 || ques.ui_category_id ==7 || ques.ui_category_id ==8">
                  <span 
                  class="font-weight-bold"
                  v-if="ques.option_val !=null && ques.option_val !=null">
                  Min value:{{ques.option_val.min_value}}<br>
                  Max value:{{ques.option_val.max_value}}
                  </span>
                  <span 
                  class="font-weight-bold"
                  v-if="ques.option_val !=null">
                  <br>
                  interval:{{ques.option_val.interval}}
                  </span> 
                </div>
              </div>
            <!-- edn question part -->
            <!-- question logic block -->
            <div v-if="ques.has_logic">
              <question-logic :question_logic="parseDataToJson(ques.question_logic.question_logic)" :questions="questionsData" :counter_index="index"/>
            </div>
          </div>

        </v-card-text>

      </v-card>

    </v-flex>

  </v-layout> 
</template>
<script>
import {mapGetters} from 'vuex'
import { QuestionLogic } from "@/components/index";
  export default {
    props: {
      questionsData: [],
      project_language: Number,
      baseUrl:String,
    },
    components:{
    QuestionLogic
    },
    
    computed: {
      ...mapGetters(['indexData', 'error', 'statusCode', 'errorMsg']),
      isLoaded() {
        if (this.indexData.dataStatus8) {
          return true;
        } else {
          return false;
        }
      }, 
    },

    // created () {
    //   this.initialize('indexData.dataStatus8')
    // },

    methods: {
      initialize () {
      },
      parseDataToJson(value){
        if(value != undefined){
          return JSON.parse(value);
        }
        return "";
        
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },
    }
  }
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem
  .imageResize
    width: auto
    height: auto
  .project {
    background: #ff2e2e;
  }
</style>